import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams, type OpenCreditPackModalLocations } from '../types';
import META from './useTrackCreditPackPurchaseInitiated.meta';

export type UseTrackCreditPackPurchaseInitiatedParams = CreditAnalyticsParams & {
  pack_quantity: number;
  source?: Exclude<OpenCreditPackModalLocations, 'checkout'>;
};

export const useTrackCreditPackPurchaseInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackPurchaseInitiated = useCallback(
    (params: UseTrackCreditPackPurchaseInitiatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackPurchaseInitiated };
};
